// extracted by mini-css-extract-plugin
export var headercontainer = "CategoryContent-module--headercontainer--b0028";
export var justifyContent = "CategoryContent-module--justifyContent--a7e9b";
export var videoContainer = "CategoryContent-module--videoContainer--5a33c";